import { createAction } from "redux-starter-kit";
import {
  FETCH_FACTORING_PROFILE_FAILURE,
  FETCH_FACTORING_PROFILE_REQUEST,
  FETCH_FACTORING_PROFILE_SUCCESS
} from "../types";

const fetchFactringProfile = id => async (dispatch, getState, { api }) => {
  try {
    dispatch(createAction(FETCH_FACTORING_PROFILE_REQUEST)());
    const response = await api.factoring.getProfile(id);
    dispatch(createAction(FETCH_FACTORING_PROFILE_SUCCESS)(response));
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_FACTORING_PROFILE_FAILURE)(err));
    throw err;
  }
};

export default fetchFactringProfile;
